// Wizard configuration: 5 phases (steps 0-4)
// Each step has its own accent color and field definitions.

export const PHASES = [
  {
    id: 0,
    label: "Phase 0 von 5 — Ziel klären",
    title: "Was willst du mit dieser Nachricht erreichen?",
    subtitle:
      "Bevor wir loslegen, lass uns dein Ziel klären. Ein klares Ziel ist die halbe Miete.",
    accent: {
      // gray
      hex: "#94a3b8",
      bar: "bg-slate-400",
      chip: "bg-slate-100 text-slate-700 border-slate-200",
      ring: "ring-slate-200",
    },
    fields: [
      {
        key: "goal",
        kind: "textarea",
        label: "Was willst du konkret erreichen?",
        rows: 4,
        placeholder: "z. B. Das Team setzt die neue Regel bis Freitag um.",
      },
      {
        key: "successMetric",
        kind: "input",
        label: "Woran erkennst du, dass du es erreicht hast?",
        placeholder: "z. B. 3 von 5 bestätigen.",
      },
      {
        key: "mustHave",
        kind: "textarea",
        label: "Was ist dir besonders wichtig — was darf nicht fehlen?",
        rows: 3,
      },
    ],
  },
  {
    id: 1,
    label: "Phase 1 von 5 — Katze abholen",
    title: "Katze abholen",
    subtitle:
      "Die Katze ist der Empfänger, der als Erstes emotional aussteigt. Hier entscheidet sich, ob sie überhaupt weiterliest.",
    accent: {
      hex: "#10B981", // emerald-500
      bar: "bg-emerald-500",
      chip: "bg-emerald-50 text-emerald-700 border-emerald-100",
      ring: "ring-emerald-200",
    },
    fields: [
      {
        key: "audience",
        kind: "select",
        label: "Wen genau erreichst du?",
        placeholder: "Empfängerkreis auswählen",
        options: [
          "Einzelne Person",
          "Kleines Team",
          "Großes Team",
          "Gemischter Kreis",
          "Externer Stakeholder",
        ],
      },
      {
        key: "emotionalBenefit",
        kind: "textarea",
        label:
          "Was hat der Empfänger emotional davon, wenn er deine Botschaft annimmt?",
        rows: 4,
        placeholder:
          "z. B. Weniger Hin-und-Her, klarere Spielführung, endlich durchziehen.",
      },
      {
        key: "options",
        kind: "textarea",
        label: "Welche Optionen oder Freiheitsgrade bietest du an?",
        rows: 3,
        placeholder: "z. B. Drei Wege zur Umsetzung — das Team entscheidet.",
      },
      {
        key: "tone",
        kind: "textarea",
        label: "Welcher Ton passt? Welche Wörter solltest du vermeiden?",
        rows: 3,
      },
    ],
  },
  {
    id: 2,
    label: "Phase 2 von 5 — Eule überzeugen",
    title: "Eule überzeugen",
    subtitle:
      "Die Eule will das große Bild verstehen. Big Picture, Daten, Fakten, Sinn.",
    accent: {
      hex: "#7A92D4", // blue-500
      bar: "bg-blue-500",
      chip: "bg-blue-50 text-blue-700 border-blue-100",
      ring: "ring-blue-200",
    },
    fields: [
      {
        key: "bigPicture",
        kind: "textarea",
        label: "In welchem größeren Zusammenhang steht dein Flexpfad?",
        rows: 4,
        placeholder:
          "z. B. Q3: 3 Kunden abgesprungen wegen langer Durchlaufzeit.",
      },
      {
        key: "facts",
        kind: "textarea",
        label:
          "Welche Zahlen, Daten, Fakten, Beispiele untermauern deine Botschaft?",
        rows: 4,
        placeholder:
          "z. B. Studien zeigen 20–30 % kürzere Vertriebszyklen mit Stage-Gating.",
      },
      {
        key: "relevance",
        kind: "textarea",
        label: "Warum ist das jetzt relevant?",
        rows: 3,
      },
    ],
  },
  {
    id: 3,
    label: "Phase 3 von 5 — Biene ermöglichen",
    title: "Biene ermöglichen",
    subtitle:
      "Die Biene will wissen, was genau zu tun ist. Schritt für Schritt.",
    accent: {
      hex: "#F3651D", // amber-500
      bar: "bg-amber-500",
      chip: "bg-amber-50 text-amber-800 border-amber-100",
      ring: "ring-amber-200",
    },
    fields: [
      {
        key: "todos",
        kind: "textarea",
        label: "Was konkret ist zu tun?",
        rows: 4,
        placeholder: "1. Anfrage einreichen\n2. Approval\n3. Versand",
      },
      {
        key: "watchOuts",
        kind: "textarea",
        label: "Worauf sollte unbedingt geachtet werden?",
        rows: 3,
      },
      {
        key: "steps",
        kind: "textarea",
        label: "Wie sieht das Schritt-für-Schritt-Vorgehen aus?",
        rows: 5,
        placeholder: "1. ...\n2. ...\n3. ...",
      },
      {
        key: "successSignals",
        kind: "textarea",
        label: "Woran erkenne ich, dass alles richtig läuft?",
        rows: 3,
      },
    ],
  },
  {
    id: 4,
    label: "Phase 4 von 5 — Hund führen",
    title: "Hund führen",
    subtitle:
      "Der Hund braucht Führung und fragt: Was bedeutet mein Handeln für andere?",
    accent: {
      hex: "#EF4444", // red-500
      bar: "bg-red-500",
      chip: "bg-red-50 text-red-700 border-red-100",
      ring: "ring-red-200",
    },
    fields: [
      {
        key: "personalConsequence",
        kind: "textarea",
        label: "Was ist die persönliche Konsequenz für den Empfänger?",
        rows: 3,
      },
      {
        key: "ifThen",
        kind: "textarea",
        label: "Was passiert, wenn er es tut — und was, wenn nicht?",
        rows: 4,
      },
      {
        key: "consequencesForOthers",
        kind: "textarea",
        label: "Was sind die Konsequenzen für andere?",
        rows: 4,
      },
      {
        key: "nextAction",
        kind: "textarea",
        label: "Was ist der nächste Schritt, und zwar jetzt?",
        rows: 2,
        placeholder: "z. B. Bis Freitag kurze Bestätigung an mich.",
      },
    ],
  },
];

export const TOTAL_STEPS = PHASES.length; // 5
export const WIZARD_STORAGE_KEY = "4ft_cocreator_draft_v1";
